/** Logged-out splash. Sends user to identity-service /login. */
export function LoggedOut() {
  const next = window.location.pathname + window.location.search
  // identity-service serves /login at the same nginx host (empathycorp.us).
  // Same-origin redirect lets the cookie land on the parent domain so it's
  // returned for money.empathycorp.us too.
  const loginHref =
    (import.meta as any).env?.VITE_LOGIN_URL ||
    `https://auth.empathycorp.us/login?next=${encodeURIComponent(window.location.origin + (next || '/'))}`
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-sm w-full text-center">
        <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2">money</div>
        <h1 className="text-2xl font-light text-zinc-100 mb-6">sign in to continue</h1>
        <a
          href={loginHref}
          className="inline-block px-6 py-2.5 rounded bg-zinc-100 text-zinc-900 text-sm font-medium hover:bg-white transition-colors"
        >
          continue with empathy
        </a>
        <div className="mt-10 text-[11px] text-zinc-600 leading-relaxed">
          auth provided by identity-service:3554 · session cookie shared across
          empathycorp.us subdomains
        </div>
      </div>
    </div>
  )
}
